<div class="timepicker">
  <button
    type="button"
    class="timepicker__button button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleOpen()"
    [disabled]="isDisabled()"
    [attr.data-outline]="outline()"
  >
    <i class="button__icon icon icon-clock-outline"></i>
    <span class="button__content">
      <span class="button__content_label">{{ label() }}</span>
      <span class="button__content_selected-time" [class.placeholder]="!selectedTime()">
        @if (selectedTime(); as time) {
          {{ time | date: 'hh:mm aa' }}
        } @else {
          Select time
        }
      </span>
    </span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isTimePickerOpen()"
    (overlayOutsideClick)="closeTimePicker()"
  >
    <div class="timepicker__dropdown dropdown">
      <div class="dropdown__selector hour">
        <h5 class="dropdown__selector_title">Hours</h5>

        <ul class="dropdown__selector_options selector-options">
          @for (hourOption of HOUR_OPTIONS; track $index) {
            <li class="selector-options__item">
              <button
                type="button"
                class="selector-options__item_button"
                [ngClass]="{ selected: hour() === hourOption }"
                (click)="onHourClick(hourOption)"
              >
                {{ hourOption | number: '2.0' }}
              </button>
            </li>
          }
        </ul>
      </div>
      <div class="dropdown__selector minute">
        <h5 class="dropdown__selector_title">Minutes</h5>

        <ul class="dropdown__selector_options selector-options">
          @for (minuteOption of MINUTE_OPTIONS; track $index) {
            <li class="selector-options__item">
              <button
                type="button"
                class="selector-options__item_button"
                [ngClass]="{ selected: minute() === minuteOption }"
                (click)="onMinuteClick(minuteOption)"
              >
                {{ minuteOption | number: '2.0' }}
              </button>
            </li>
          }
        </ul>
      </div>
      <div class="dropdown__selector period">
        <h5 class="dropdown__selector_title">Period</h5>

        <ul class="dropdown__selector_options selector-options">
          @for (periodOption of PERIOD_OPTIONS; track $index) {
            <li class="selector-options__item">
              <button
                type="button"
                class="selector-options__item_button"
                [ngClass]="{ selected: period() === periodOption }"
                (click)="onPeriodClick(periodOption)"
              >
                {{ periodOption }}
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </ng-template>
</div>
